module.exports = __webpack_public_path__ + "img/elmentary-virtual-2022-robomission.0b0afd3d.png";